export default __webpack_public_path__ + "static/woman-on-bridge-061caa7aeb9e7e2eeae9d7bb62834b5e.jpg";